import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { RegisterUserStepFormSchema, RegisterUserStepMutation } from './RegisterUserStepForm.types';
import { useMutation, useQueryClient } from 'react-query';
import { REGISTER_USER_QUERY_KEY, registerUserQuery } from './RegisterUserStepForm.query';
import Form from '../../../../../commons/Form/Form';
import { registerUserStepData } from './RegisterUserStepForm.data';
import { getRegisterUserStepSchema } from './RegisterUserStepForm.schema';
import { useCurrentUser } from '../../../../../../hooks/useCurrentUser/useCurrentUser';
import { User, UserRoles } from '../../../../../../types/models/user/user.types';
import { useCookies } from 'react-cookie';
import { useState } from 'react';
import LoginPUBModal from '../../../LoginPUB/LoginPUBModal/LoginPUBModal';
import { api } from '../../../../../../utils/api/api';
import { setProfile } from '../../../../../../store/authentication/authenticationActions/authenticationActions';
import moment from 'moment';
import { RegisterStepsList } from '../../RegisterSteps.types';
import { getStepIdFromPUBStep } from '../../../../../../utils/helpers/user/getStep';
import { useDispatch } from 'react-redux';

export default () => {

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const [, setCookie, removeCookie] = useCookies(['token']);

  const currentUser = useCurrentUser() as User;

  const [isModalOpen, setModalOpen] = useState(false);

  const formProps = useForm<RegisterUserStepFormSchema>({
    resolver: yupResolver(getRegisterUserStepSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      email: currentUser.email,
    },
  });

  const { handleSubmit } = formProps;

  const IS_ACTUAL_LOGIN_ENABLED = true;

  const { mutate } = useMutation<
    Awaited<ReturnType<RegisterUserStepMutation>>,
    Error,
    RegisterUserStepFormSchema
  >((data) => registerUserQuery(data), {
    mutationKey: REGISTER_USER_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: ({ user, accessToken }) => {
      if (IS_ACTUAL_LOGIN_ENABLED) {
        api.setHeader('authorization', `Bearer ${accessToken}`);
        removeCookie('token', { path: '/' });
        setCookie('token', accessToken, {
          expires: moment().add(60, 'minutes').toDate(),
          path: '/',
        });
        setProfile({ ...user, id_step: getStepIdFromPUBStep(RegisterStepsList.User) })(dispatch);
        // navigate('/dashboard');
      } else {
        removeCookie('token', { path: '/' });
        setModalOpen(true);
      }
    },
    onError: (error) => {
      alert(error.message);
    },
  });

  const onSubmit = handleSubmit((data) => mutate(data));

  return (
    <>
      <Form<RegisterUserStepFormSchema>
        data={registerUserStepData}
        {...{ formProps, onSubmit }}
        isCompany={currentUser.role === UserRoles.Entreprise}
        isRegisterStep
      />
      <LoginPUBModal isOpen={isModalOpen} setOpen={setModalOpen} />
    </>
  );
};
